<template>
    <section class="section-my-class-school">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/danh-sach-lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="">{{ className }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="row col-md-12">
                <div class="col-md-8 header-detail-class-school pl-0">
                    <div class="title-class-school pt-4">
                        <strong>
                            <h3 class="font-weight-bold">{{ className }}</h3>
                        </strong>
                    </div>
                    <div class="title-name-school">
                        Giáo viên: {{ dataClassSchool.teacherName }}
                    </div>
                </div>

                <div class="col-md-4 header-detail-class-school pr-0" style="text-align: right">
                    <div class="title-class-school" style="padding-top: 2.5rem !important">
                        Sĩ số: {{ dataClassSchool.countMember }}
                    </div>
                    <div class="title-name-school">
                        Trường học: {{ dataClassSchool.nameSchool }}
                    </div>
                </div>
            </div>
            <b-tabs class="pre-class-school-list__filter__tabs b-class-tabs">
                <b-tab @click="changeTab(tabExcerciseClassSchool)" title="Danh sách bài tập/ bài kiểm tra"
                    :active="tabActive == tabExcerciseClassSchool">
                    <ExcerciseClassSchool v-if="tabActive == tabExcerciseClassSchool" :className="className" />
                </b-tab>
                <b-tab @click="changeTab(tabElectronicLectures)" title="Danh sách bài giảng điện tử"
                    :active="tabActive == tabElectronicLectures">
                    <ElectronicLectures v-if="tabActive == tabElectronicLectures" :className="className" />
                </b-tab>
                <b-tab @click="changeTab(tabLessonPlanning)" title="Danh sách kế hoạch bài dạy"
                    :active="tabActive == tabLessonPlanning">
                    <LessonPlanning v-if="tabActive == tabLessonPlanning" :className="className" />
                </b-tab>
                <b-tab @click="changeTab(tabGroup)" title="Danh sách nhóm" :active="tabActive == tabGroup">
                    <ListGroup v-if="tabActive == tabGroup" />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>
<script>
import ElectronicLectures from './_components/ElectronicLectures.vue'
import ExcerciseClassSchool from './_components/ExcerciseClassSchool.vue'
import LessonPlanning from './_components/LessonPlanning.vue'
import ListGroup from './_components/ListGroup.vue'
import { getDetail } from './../_api/classSchoolServices'
export default {
    components: {
        ExcerciseClassSchool,
        ElectronicLectures,
        LessonPlanning,
        ListGroup
    },
    data() {
        return {
            classSchoolId: 0,
            className: '',
            classObj: null,
            tabActive: 1,
            tabExcerciseClassSchool: 1,
            tabElectronicLectures: 2,
            tabLessonPlanning: 3,
            tabGroup: 4,
            dataClassSchool: {
                id: 0,
                nameSchool: "",
                code: "",
                name: "",
                password: "",
                classId: "",
                subjectId: "",
                teacherName: "",
                countMember: 0,
            },
        }
    },
    mounted() {
        this.classSchoolId = this.$router.history.current.query.id
        this.className = this.$router.history.current.query.nameClass
        if (this.$route.query.tab) {
            this.tabActive = this.$route.query.tab
        }
        this.getDetailClassSchool()
    },
    methods: {
        changeTab(tab) {
            this.tabActive = tab
        },
        getDetailClassSchool() {
            let self = this;
            getDetail(this.classSchoolId).then((res) => {
                if (res && res.data && !res.errors) {
                    self.dataClassSchool = {
                        id: res.data.id,
                        nameSchool: res.data.nameSchool,
                        code: res.data.code,
                        name: res.data.name,
                        password: res.data.password,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        subjectName: res.data.subjectName,
                        teacherName: res.data.teacherName,
                        countMember: res.data.countMember,
                    };
                }
            });
        },
    }
}
</script>